// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gw-0";
export var fulfillmentPanelBody = "_gw-1";